export const environment = {
  production: false,
  url: 'https://api.amsyst.com/'
};